import { PaymentType } from './payment-type';
import { SystemUser } from './system-user';
import Decimal from 'decimal.js';
import { Currency } from './currency';
import { Moment } from 'moment';

export class PaymentReceived {

    constructor(
        public comment: string,
        public date: Moment,
        public amount: Decimal,
        public paymentType: PaymentType,
        public invoiceNumber: string,
        public currency: Currency,
        public isFinancialRecord: boolean,
        public created?: Moment,
        public createdBy?: SystemUser,
        public lastModified?: Moment,
        public lastModifiedBy?: SystemUser,
        public id?: number,
        public sortOrder?: number,
        public amountInEuro?: Decimal,
        public hidden?: boolean
    ){}
}
